import React from 'react'
import { Row, Col } from 'react-bootstrap'
import styled from 'styled-components'

const List = styled.ul`
  padding: 1em 0.5em;
`

const Item = styled.li`
  color: #ff0000;
  font-size: 1.25em;
`

const Link = styled.a`
  text-decoration: underline;
`
const Bold = styled.b`
  font-weight: 600;
  font-family: 'Roboto Bold';
`

const CountryWarnings = props => {
  const { country, status } = props

  // Currently we only need this for AU
  // I would recommend refactoring into a switch with each text section in individual functions if it needs more countries

  if (country === 'AU' && status) {
    return (
      <Row>
        <Col xs={12}>
          <List>
            <Item>
              If the right to work document provided is a visa, you{' '}
              <Bold>must</Bold> check the conditions and validity of the visa{' '}
              <Link
                href="https://immi.homeaffairs.gov.au/visas/already-have-a-visa/check-visa-details-and-conditions/check-conditions-online"
                target="_blank"
              >
                here
              </Link>
              {''}.
            </Item>
            <Item>
              If the visa is not valid or it does not allow the user to work,{' '}
              <Bold>do not approve the BA</Bold>.
            </Item>
          </List>
        </Col>
      </Row>
    )
  } else {
    return null
  }
}

export default CountryWarnings
